export default "__VITE_ASSET__B8sEg9px__"